import { InputTextarea } from 'primereact/inputtextarea';
import { type KeyboardEvent } from 'react';

import { cn } from '@shared/lib/cn';

export interface BaseTextareaProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  disabled?: boolean;
  maxLength?: number;
  className?: string;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  'aria-label'?: string;
}

/** Multi-line notes (task remarks, query text). Grows with its content. */
export function BaseTextarea({
  id,
  value,
  onChange,
  placeholder,
  rows = 3,
  disabled,
  maxLength,
  className,
  onKeyDown,
  'aria-label': ariaLabel,
}: BaseTextareaProps) {
  return (
    <InputTextarea
      id={id}
      name={id}
      value={value}
      rows={rows}
      autoResize
      onChange={(e) => {
        onChange(e.target.value);
      }}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={maxLength}
      onKeyDown={onKeyDown}
      aria-label={ariaLabel}
      className={cn('w-full', className)}
    />
  );
}
